'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { More, MorePopup, MoreWrapper, MoreItem, MoreIcon } from './SettingJob.css.js';
import HideIcon from '../Images/HideIcon/index.js';
import VerticalMoreIcon from '../Images/VerticalMoreIcon/index.js';
import useClickOutSide from '../hooks/useClickOutSide.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import { ELanguage } from '../Utils/constants.js';
import '../services/resumes/types.js';
import { useMountTransition } from '../Utils/hooks.js';
import { hideJob, unhideJob } from './services.js';
import { showToast } from '../Toast/index.js';
import Button from '../Button/index.js';

var SettingJob = forwardRef(function (props, ref) {
    var api = props.api, jobId = props.jobId, langCode = props.langCode, onHideJobClick = props.onHideJobClick, onShowChange = props.onShowChange, isHide = props.isHide, _a = props.type, type = _a === void 0 ? 'vertical' : _a, _b = props.showPopupType, showPopupType = _b === void 0 ? 'bottom' : _b, _c = props.className, className = _c === void 0 ? '' : _c;
    var _d = useClickOutSide(false), elementRef = _d.elementRef, isVisible = _d.isVisible, setElementVisible = _d.setElementVisible;
    var hasTransitionedIn = useMountTransition(isVisible, 250);
    var isVI = langCode === ELanguage.VI;
    var isWindow = typeof window !== 'undefined';
    var showLoginModal = function () {
        if (isWindow) {
            var loginEvent = new CustomEvent('LOGIN_POPUP', {
                detail: {
                    langCode: langCode === ELanguage.VI ? 'vi' : 'en'
                }
            });
            window.dispatchEvent(loginEvent);
        }
    };
    var handleShowPopup = function (isShow) {
        setElementVisible(isShow);
    };
    var handleHideJobClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, error, message;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    handleShowPopup(false);
                    if (!api.accessToken) {
                        showLoginModal();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, hideJob(__assign({ jobId: jobId, langCode: langCode, accessToken: '' }, api))];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (data) {
                        onHideJobClick(jobId);
                    }
                    else {
                        message = error;
                        if (error === 'jobId exists') {
                            message = isVI ? 'Bạn đã ẩn công việc này.' : 'You have hidden this job.';
                        }
                        showToast(isVI ? 'Ẩn việc làm' : 'Hide job', message, 'error');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUnhideJobClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, unhideJob(__assign({ jobId: jobId, langCode: langCode, accessToken: '' }, api))];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (data) {
                        onHideJobClick(jobId);
                    }
                    else {
                        showToast(isVI ? 'Ẩn việc làm' : 'Hide job', error, 'error');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        onShowChange && onShowChange(isVisible);
    }, [isVisible]);
    useImperativeHandle(ref, function () { return ({
        isShow: isVisible,
        onLeaveSetting: function () {
            setElementVisible(false);
        }
    }); });
    if (isHide) {
        return (React__default.createElement(Button, { type: 'outline', onClick: handleUnhideJobClick }, isVI ? 'Hoàn tác' : 'Undo'));
    }
    return (React__default.createElement(More, { ref: elementRef, isShowPopup: isVisible, className: className },
        React__default.createElement(VerticalMoreIcon, { style: { transform: type === 'horizontal' ? 'rotate(90deg)' : '' }, width: 20, onClick: function () { return handleShowPopup(!isVisible); } }),
        (isVisible || hasTransitionedIn) && (React__default.createElement(MorePopup, { showType: showPopupType },
            React__default.createElement(MoreWrapper, { showType: showPopupType, active: isVisible && hasTransitionedIn },
                React__default.createElement(MoreItem, { className: 'SJ_HideJob', onClick: handleHideJobClick },
                    React__default.createElement(MoreIcon, null,
                        React__default.createElement(HideIcon, null)),
                    React__default.createElement("span", null, isVI ? 'Ẩn việc làm này' : 'Hide this job')))))));
});

export { SettingJob as default };
//# sourceMappingURL=index.js.map
